import {Component} from "@angular/core";
import {FUIAbstractToggle} from "../abstract-toggle";

@Component({
    selector: "fui-mark-toggle",
    styleUrls: ["./mark-toggle.component.scss"],
    templateUrl: "./mark-toggle.component.html",
    standalone: false
})
export class FUIMarkToggleComponent extends FUIAbstractToggle {

}
